import React from 'react';
import { Link } from 'react-router-dom';
import HarbourIcon from './HarbourIcon';
import './harbour.css';

/*
 * Harbour/Text link: the underlined plum link, the honest escape. Renders a
 * router Link when `to` is given, otherwise a button. `size="standard"` adds
 * the 48px touch padding used for standalone links like "All school forms".
 */
export default function HarbourTextLink({
  to,
  onClick,
  leadingIcon,
  size = 'inline',
  children,
  className = '',
  ...rest
}) {
  const classes = [
    'harbour-text-link',
    size === 'standard' ? 'harbour-text-link--standard' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {leadingIcon && <HarbourIcon name={leadingIcon} size={20} />}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick} {...rest}>
        {content}
      </Link>
    );
  }
  return (
    <button type="button" className={classes} onClick={onClick} {...rest}>
      {content}
    </button>
  );
}
